export const AdditionalDriverResources = {
    es: {
        ['title']: 'Conductores Adicionales',
        ['additional_driver']: 'Conductor Adicional',
        ['click_capture_license']: 'Click aquí para capturar tu licencia',
        ['video_not_supported']: 'Tu navegador no soporta el tag de video.',
        ['take_photo']: 'Tomar Foto',
        ['full_name']: 'Nombre Completo',
        ['expiration_date']: 'Fecha de expiración',
        ['signature_optional']: 'Firma (Opcional)',
        ['actions']: 'Acciones',
        ['first_name']: 'Nombre',
        ['last_name']: 'Apellidos',
        ['phone']: 'Teléfono',
        ['birth_date']: 'Fecha de nacimiento',
        ['state']: 'Estado',
        ['country']: 'País',
        ['license_number']: 'No. Licencia',
        ['license_expiration_date']: 'Vigencia',
        ['click_to_add']: 'Clic aquí para añadir',
        ['remove_additional_driver']: 'Remover Conductor Adicional',
        ['confirm_remove_driver']: '¿Estas seguro de querer quitar el conductor: {{fullName}}?',
        ['confirm']: 'Confirmar',
        ['cancel']: 'Cancelar',
        ['edit_additional_driver']: 'Editar datos del conductor adicional',
        ['additional_driver_signature']: 'Firma del conductor adicional',
        ['additional_driver_data']: 'Conductor Adicional',
        ['drivers_limit_mismatch']: 'Coductores adiconales excedieron el limite ({{limit}}), por favor elimine algun registro',
        ['add_driver']: 'Añadir conductor',
        ['add_driver_desc']: 'Añade a los conductores seleccionados.',
        ['take_photo']: 'Tomar Foto',
        ['license_file']: 'Archivo de Licencia',
        ['pending']: 'Pendiente',
    },
    en: {
        ['title']: 'Additional Drivers',
        ['additional_driver']: 'Additional Driver',
        ['click_capture_license']: 'Click here to capture your license',
        ['video_not_supported']: 'Your browser does not support the video tag.',
        ['take_photo']: 'Take Photo',
        ['full_name']: 'Full Name',
        ['expiration_date']: 'Expiration date',
        ['signature_optional']: 'Signature (Optional)',
        ['actions']: 'Actions',
        ['first_name']: 'First Name',
        ['last_name']: 'Last Names',
        ['phone']: 'Phone',
        ['birth_date']: 'Date of birth',
        ['state']: 'State',
        ['country']: 'Country',
        ['license_number']: 'License No.',
        ['license_expiration_date']: 'Expiration',
        ['click_to_add']: 'Click here to add',
        ['remove_additional_driver']: 'Remove Additional Driver',
        ['confirm_remove_driver']: 'Are you sure you want to remove the driver: {{fullName}}?',
        ['confirm']: 'Confirm',
        ['cancel']: 'Cancel',
        ['edit_additional_driver']: 'Edit additional driver data',
        ['additional_driver_signature']: 'Additional driver signature',
        ['additional_driver_data']: 'Additional Driver',
        ['drivers_limit_mismatch']: 'Additional drivers exceeded the limit ({{limit}}). Please remove a record',
        ['add_driver']: 'Add Driver',
        ['add_driver_desc']: 'Add the selected drivers.',
        ['take_photo']: 'Take Photo',
        ['license_file']: 'License File',
        ['pending']: 'Pending',
    }
}
